import Spinner from "components/Spinner";
import React, { useRef, useState } from "react";
import authHeader from "services/auth-header";
import API from "services/axios";
import LocationEmailTemplateFields, {
  getTemplateApiPayloadList,
  stripLocationTemplateFields,
  validateLocationEmailTemplates,
} from "./locationEmailTemplateFields";

function LocationAdd({ showAddPage, refreshFunc, lastSortId }) {
  const user = JSON.parse(localStorage.getItem("user"));
  /*   All States Below
   ********************************************* */
  const [formError, setFormError] = useState({});
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const submitActionRef = useRef("save");

  const [files, setFiles] = useState({});

  /*   All Functions
   ********************************************* */
  const handleFileChange = (e) => {
    let file = e.target.files[0];

    let path = {
      panelLogo: `kms/companyLogos/${user?.companyId}/locationLogo`,
      pdfLogo: `kms/companyLogos/${user?.companyId}/locationLogo/pdfLogo`,
    };

    let fileData = {
      file: file,
      fileName: file.name,
      folder: path[e.target.name],
    };

    setFiles((prev) => {
      return { ...prev, [e.target.name]: fileData };
    });
  };

  const addLocationData = async (e) => {
    setFormError({});
    e.preventDefault();
    setLoading(true);
    if (!formData.locationName?.trim()) {
      setFormError({
        locationName: {
          type: "locationName",
          message: "Brand Name is required",
        },
      });
      setLoading(false);
      return;
    }

    const { isValid: templatesValid, errors: templateErrors } =
      validateLocationEmailTemplates(formData);
    if (!templatesValid) {
      const messages = Object.values(templateErrors)
        .flatMap((e) => Object.values(e))
        .join("\n");
      alert(`Please fix the following before saving:\n\n${messages}`);
      setLoading(false);
      return;
    }

    const formDataValue = new FormData();

    const updatedData = stripLocationTemplateFields({
      ...formData,
      sortId: lastSortId + 1,
    });
    formDataValue.append("updatedData", JSON.stringify(updatedData));

    const templatePayloadList = getTemplateApiPayloadList(formData);

    Array.from(Object.keys(files)).map((key) => {
      formDataValue.append(`file`, files[key].file);
    });
    formDataValue.append("filesData", JSON.stringify(files));

    try {
      const { data } = await API.post("/locations", formDataValue, {
        headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
      });
      if (data.message.type === "success") {
        const createdLocationId =
          data?.data?.id ||
          data?.id ||
          data?.location?.id ||
          data?.message?.data?.id ||
          null;

        if (createdLocationId) {
          await Promise.all(
            templatePayloadList.map((payload) =>
              API.post(`/locations/${createdLocationId}/templates`, payload, {
                headers: authHeader(),
              }),
            ),
          );
        } else {
          const refreshedLocations = await API.get("/locations", {
            headers: authHeader(),
          });

          const matchedLocation = (refreshedLocations?.data || [])
            .filter(
              (location) =>
                location?.sortId === lastSortId + 1 &&
                location?.locationName === updatedData.locationName,
            )
            .sort((a, b) => (b?.id || 0) - (a?.id || 0))[0];

          if (matchedLocation?.id) {
            await Promise.all(
              templatePayloadList.map((payload) =>
                API.post(
                  `/locations/${matchedLocation.id}/templates`,
                  payload,
                  {
                    headers: authHeader(),
                  },
                ),
              ),
            );
          } else {
            throw new Error(
              "Brand created, but could not resolve id to save templates.",
            );
          }
        }

        refreshFunc();
        setLoading(false);

        if (submitActionRef.current === "save-close") {
          showAddPage(false);
        } else {
          setFormData({});
          setFiles({});
          setFormError({});
        }
        return;
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      alert(err.message);
    }
  };

  const updateInput = (e) => {
    setFormData((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };

  return (
    <div className="row">
      <div className="col-12">
        {loading && <Spinner />}
        {/*    ADD FORM START
         ********************************************* */}
        <div className="mb-13 ms-3">
          <h3>Add Brand</h3>
        </div>
        <form className="ps-3 pe-3" onSubmit={addLocationData}>
          {/* ----------  Fields  ----------- */}
          <div className="mt-3 mb-3">
            <label htmlFor="title" className="form-label">
              Brand Name
            </label>
            <input
              className="form-control"
              type="text"
              id="locationName"
              placeholder="Enter title"
              name="locationName"
              onChange={updateInput}
            />
            {formError && formError.locationName && (
              <p className="text-danger">{formError.locationName.message}</p>
            )}
          </div>
          <div className="mb-3">
            <label htmlFor="companyName" className="form-label">
              Company Name
            </label>
            <input
              className="form-control"
              type="text"
              id="companyName"
              placeholder="Enter company name"
              name="companyName"
              onChange={updateInput}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="logo" className="form-label">
              Pdf Logo ( W x H : 200px x 100px )
            </label>
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-grow-1">
                <input
                  className="form-control"
                  type="file"
                  id="pdfLogo"
                  name="pdfLogo"
                  onChange={handleFileChange}
                />
              </div>
            </div>
          </div>

          <LocationEmailTemplateFields
            formData={formData}
            setFormData={setFormData}
          />

          <div className={`mt-4 mb-2 d-flex justify-content-end`}>
            <div>
              <button
                className="btn px-1 btn-secondary"
                type="button"
                onClick={() => {
                  showAddPage(false);
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-success ms-1"
                type="submit"
                onClick={() => {
                  submitActionRef.current = "save";
                }}
              >
                Add
              </button>
              <button
                className="btn btn-primary ms-1"
                type="submit"
                onClick={() => {
                  submitActionRef.current = "save-close";
                }}
              >
                Add and Close
              </button>
            </div>
          </div>
        </form>

        {/*    ADD FORM END
         ********************************************* */}
      </div>
    </div>
  );
}

export default LocationAdd;
